/*!
 * Copyright 2020 Fondazione Bruno Kessler
 * Licensed under the EUPL, Version 1.1 or - as soon they will be approved by the European
 * Commission - subsequent versions of the EUPL (the "Licence"); You may not use this work
 * except in compliance with the Licence.
 *
 * You may obtain a copy of the Licence at:
 * http://ec.europa.eu/idabc/eupl.html
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the Licence is distributed on an "AS IS" basis, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the Licence for the specific language
 * governing permissions and limitations under the Licence.
 */

import {ChangeDetectionStrategy, Component} from "@angular/core";
// eslint-disable-next-line max-len
import {NotificationInfoDialogComponent} from "@app/modules/messages/components/notification-info-dialog/notification-info-dialog.component";
import {ModalController} from "@ionic/angular";
import {PushManagerService} from "../../services/push-manager.service";

@Component({
  selector: "c3-notification-center",
  templateUrl: "./notification-center.component.html",
  styleUrls: ["./notification-center.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class NotificationCenterComponent {
  readonly pushStatus$ = this.pushManager.pushStatus$;

  constructor(private pushManager: PushManagerService, private modalCtrl: ModalController) { }

  /**
   * Button request notification permission callback.
   */
  onRequestNotificationPermissions() {
    this.pushManager.requestNotificationPermissions();
  }

  /**
   * Open notification info dialog.
   */
  async openNotificationInfoDialog() {
    const modal = await this.modalCtrl.create({
      component: NotificationInfoDialogComponent,
      componentProps: {showEnableBtn: this.pushManager.getStatus() === "need-permissions"},
    });

    modal.present();
    const enableNotificationRes = await modal.onWillDismiss();

    if (enableNotificationRes.data) {
      this.onRequestNotificationPermissions();
    }
  }
}
